// extracted by mini-css-extract-plugin
export default {"container":"HeaderFooterLayout_container__e30kL","content":"HeaderFooterLayout_content__mE7u4"};